/* Keep the localized artwork consistent in the Focal gallery zoom. */
customElements.whenDefined("product-image-zoom").then(() => {
  const Zoom = customElements.get("product-image-zoom");
  const previous = Zoom?.prototype._buildItems;
  if (typeof previous !== "function" || Zoom.prototype.dipsyImageLanguageEnabled) return;
  Zoom.prototype.dipsyImageLanguageEnabled = true;
  Zoom.prototype._buildItems = async function () {
    const items = await previous.call(this);
    const slides = [...this.mediaElement.querySelectorAll('.product__media-item[data-media-type="image"]:not(.is-filtered)')];
    return items.map((item, index) => {
      const image = slides[index]?.querySelector("img[data-dipsy-localized-src]");
      const width = Number(image?.dataset.dipsyLocalizedWidth);
      const height = Number(image?.dataset.dipsyLocalizedHeight);
      if (!image || !width || !height) return item;
      const source = new URL(image.dataset.dipsyLocalizedSrc, window.location.href);
      source.searchParams.delete("width");
      source.searchParams.delete("height");
      const displayWidth = Math.min(width, window.innerWidth);
      return {
        ...item,
        src: image.dataset.dipsyLocalizedSrc,
        msrc: image.currentSrc,
        w: displayWidth,
        h: Math.round(displayWidth * height / width),
        originalMedia: {
          ...item.originalMedia,
          width,
          height,
          aspect_ratio: width / height,
          preview_image: { ...item.originalMedia.preview_image, src: source.href, width, height, aspect_ratio: width / height }
        }
      };
    });
  };
});
